import {
  GET_LABREQUESTINCIDENT,
  GET_LABREQUESTINCIDENT_FAIL,
  GET_LABREQUESTINCIDENT_SUCCESS,
  GET_LABREQUESTINCIDENTS,
  GET_LABREQUESTINCIDENTS_FAIL,
  GET_LABREQUESTINCIDENTS_SUCCESS,
  ADD_NEW_LABREQUESTINCIDENT,
  ADD_LABREQUESTINCIDENT_SUCCESS,
  ADD_LABREQUESTINCIDENT_FAIL,
  UPDATE_LABREQUESTINCIDENT,
  UPDATE_LABREQUESTINCIDENT_SUCCESS,
  UPDATE_LABREQUESTINCIDENT_FAIL,
  DELETE_LABREQUESTINCIDENT,
  DELETE_LABREQUESTINCIDENT_SUCCESS,
  DELETE_LABREQUESTINCIDENT_FAIL,
  SET_STATE_LABREQUESTINCIDENT
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTINCIDENT,
  payload: loading,
})

export const getLabRequestIncidents = ( params ) => ({
  type: GET_LABREQUESTINCIDENTS,
  payload: { params },
})

export const getLabRequestIncidentsSuccess = (labRequestIncidents, totalPages, currentPage) => ({
  type: GET_LABREQUESTINCIDENTS_SUCCESS,
  payload: { labRequestIncidents:labRequestIncidents, total:totalPages, currentPage:currentPage}
})

export const getLabRequestIncidentsFail = error => ({
  type: GET_LABREQUESTINCIDENTS_FAIL,
  payload: error,
})

export const addNewLabRequestIncident = labRequestIncident => ({
  type: ADD_NEW_LABREQUESTINCIDENT,
  payload: labRequestIncident,
})

export const addLabRequestIncidentSuccess = labRequestIncident => ({
  type: ADD_LABREQUESTINCIDENT_SUCCESS,
  payload: labRequestIncident,
})  

export const addLabRequestIncidentFail = error => ({
  type: ADD_LABREQUESTINCIDENT_FAIL,
  payload: error,
})

export const updateLabRequestIncident = labRequestIncident => ({
  type: UPDATE_LABREQUESTINCIDENT,
  payload: labRequestIncident,
})

export const updateLabRequestIncidentSuccess = labRequestIncident => ({
  type: UPDATE_LABREQUESTINCIDENT_SUCCESS,
  payload: labRequestIncident,
})

export const updateLabRequestIncidentFail = error => ({
  type: UPDATE_LABREQUESTINCIDENT_FAIL,
  payload: error,
})

export const deleteLabRequestIncident = labRequestIncident => ({
  type: DELETE_LABREQUESTINCIDENT,
  payload: labRequestIncident,
})

export const deleteLabRequestIncidentSuccess = id => ({
  type: DELETE_LABREQUESTINCIDENT_SUCCESS,
  id,
})

export const deleteLabRequestIncidentFail = error => ({
  type: DELETE_LABREQUESTINCIDENT_FAIL,
  payload: error,
})

export const getLabRequestIncident = () => ({
  type: GET_LABREQUESTINCIDENT,
})

export const getLabRequestIncidentSuccess = labRequestIncident => ({
  type: GET_LABREQUESTINCIDENT_SUCCESS,
  payload: labRequestIncident,
})

export const getLabRequestIncidentFail = error => ({
  type: GET_LABREQUESTINCIDENT_FAIL,
  payload: error,
})
